module.exports = __webpack_public_path__ + "static/media/t.d61e34bd.svg";